import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

function CheckoutForm({ amount, onCancel }) {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);
    setErrorMessage(null);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/StreetPay?success=true&amount=${amount}`,
      },
    });

    if (error) {
      setErrorMessage(error.message);
      setIsProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full p-8">
      <div className="mb-6">
        <PaymentElement />
      </div>

      {errorMessage && (
        <div className="mb-4 px-4 py-3 bg-red-500/10 border-l-4 border-red-500 rounded-r">
          <p className="text-red-400 text-sm font-mono">{errorMessage}</p>
        </div>
      )}

      <div className="flex flex-col gap-3">
        <button
          type="submit"
          disabled={!stripe || isProcessing}
          className="w-full h-14 bg-green-500 hover:bg-white text-black font-bold uppercase tracking-widest text-lg transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed shadow-[0_0_15px_rgba(34,197,94,0.3)] hover:shadow-[0_0_25px_#00ff41]"
        >
          {isProcessing ? "PROCESSING..." : "CONFIRM PAYMENT"}
        </button>
        <button
          type="button"
          onClick={onCancel}
          disabled={isProcessing}
          className="w-full h-12 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-green-500/50 text-white font-mono font-semibold transition-all active:scale-95 disabled:opacity-50 uppercase tracking-widest"
        >
          Cancel
        </button>
      </div>
    </form>
  );
}

export default function StripePaymentForm({ clientSecret, stripePublishableKey, amount, onCancel }) {
  const stripePromise = loadStripe(stripePublishableKey);

  const options = {
    clientSecret,
    appearance: {
      theme: 'night',
      variables: {
        colorPrimary: '#00ff41',
        colorBackground: '#0a110e',
        colorText: '#ffffff',
        colorDanger: '#ef4444',
        fontFamily: 'Space Grotesk, monospace',
        spacingUnit: '4px',
        borderRadius: '4px',
      },
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm amount={amount} onCancel={onCancel} />
    </Elements>
  );
}
